export default {
    animation: Boolean | Object, 
    closeOnClick: Boolean, 
    dataSource: Object | Array, 
    direction: String, 
    hoverDelay: Number, 
    openOnClick: Boolean | Object, 
    orientation: String, 
    popupCollision: String, 
    scrollable: Boolean | Object, 

    // Events
    close: Function, 
    open: Function, 
    activate: Function, 
    deactivate: Function, 
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/MenuProps.js